import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, ValidationMessage, ValidationMessageType,
    TibboDataType,
    AnyLayoutElement,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export default class Tibbit_05 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_05';
        this.name = 'Tibbit 05';
        this.capabilities = ['rs485'];
        this.capabilities = ['serial'];
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.BYTE,
                required: true,
                default: '',
            },
            {
                id: 'MODE',
                name: 'Mode',
                settingType: SettingType.HIDDEN,
                required: true,
                default: 'RS485',
            },
            {
                id: 'BAUD',
                name: 'Baud Rate',
                settingType: SettingType.OPTION,
                required: true,
                default: '9600',
                linkToSetting: true,
                options: [
                    {
                        name: '1200',
                        value: '1200',
                    },
                    {
                        name: '2400',
                        value: '2400',
                    },
                    {
                        name: '4800',
                        value: '4800',
                    },
                    {
                        name: '9600',
                        value: '9600',
                    },
                    {
                        name: '19200',
                        value: '19200',
                    },
                    {
                        name: '38400',
                        value: '38400',
                    },
                    {
                        name: '57600',
                        value: '57600',
                    },
                    {
                        name: '115200',
                        value: '115200',
                    },
                    {
                        name: '230400',
                        value: '230400',
                    },
                    {
                        name: '460800',
                        value: '460800',
                    },
                    {
                        name: '921600',
                        value: '921600',
                    },
                ],
                setting: {
                    SETTINGID: 'T05BAUD',
                    NAME: 'Tibbit 05 Baud Rate',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 0,
                    MAX: 8,
                    DEFAULT: '9600',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: '1200',
                            value: '1200',
                        },
                        {
                            name: '2400',
                            value: '2400',
                        },
                        {
                            name: '4800',
                            value: '4800',
                        },
                        {
                            name: '9600',
                            value: '9600',
                        },
                        {
                            name: '19200',
                            value: '19200',
                        },
                        {
                            name: '38400',
                            value: '38400',
                        },
                        {
                            name: '57600',
                            value: '57600',
                        },
                        {
                            name: '115200',
                            value: '115200',
                        },
                        {
                            name: '230400',
                            value: '230400',
                        },
                        {
                            name: '460800',
                            value: '460800',
                        },
                        {
                            name: '921600',
                            value: '921600',
                        },
                    ],
                },
            },
            {
                id: 'FLOWCONTROL',
                name: 'Flow Control',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                linkToSetting: true,
                options: [
                    {
                        name: 'disabled',
                        value: '0',
                    },
                    {
                        name: 'XONOFF',
                        value: '2',
                    },
                ],
                setting: {
                    SETTINGID: 'FLOWCTRL',
                    NAME: 'Tibbit 05 Flow Control',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 1,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: 'disabled',
                            value: '0',
                        },
                        {
                            name: 'XONOFF',
                            value: '2',
                        },
                    ],
                },
            },
            {
                id: 'PARITY',
                name: 'Parity',
                settingType: SettingType.OPTION,
                required: true,
                linkToSetting: true,
                default: '0',
                options: [
                    {
                        name: 'None',
                        value: '0',
                    },
                    {
                        name: 'Even',
                        value: '1',
                    },
                    {
                        name: 'Odd',
                        value: '2',
                    },
                    {
                        name: 'Mark (Always 1)',
                        value: '3',
                    },
                    {
                        name: 'Space (Always 0)',
                        value: '4',
                    },
                ],
                setting: {
                    SETTINGID: 'PARITY',
                    NAME: 'Tibbit 05 Parity',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 1,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: 'None',
                            value: '0',
                        },
                        {
                            name: 'Even',
                            value: '1',
                        },
                        {
                            name: 'Odd',
                            value: '2',
                        },
                        {
                            name: 'Mark(Always 1)',
                            value: '3',
                        },
                        {
                            name: 'Space(Always 0)',
                            value: '4',
                        },
                    ],
                },
            },
            {
                id: 'BITS',
                name: 'Data Bits',
                settingType: SettingType.OPTION,
                required: true,
                linkToSetting: true,
                default: '1',
                options: [
                    {
                        name: '7 Bits',
                        value: '0',
                    },
                    {
                        name: '8 Bits',
                        value: '1',
                    },
                ],
                setting: {
                    SETTINGID: 'BITS',
                    NAME: 'Tibbit 05 Data Bits',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MIN: 1,
                    MAX: 1,
                    DEFAULT: '1',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: '7 Bits',
                            value: '0',
                        },
                        {
                            name: '8 Bits',
                            value: '1',
                        },
                    ],
                },
            },
            {
                id: 'TXBUF',
                name: 'TX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
            {
                id: 'RXBUF',
                name: 'RX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    validate(): ValidationMessage[] {
        const errors: Array<ValidationMessage> = [];
        if (this.getSettingValue('NAME').trim() === '') {
            errors.push({ message: 'Please enter value for Name', messageType: ValidationMessageType.ERROR });
        }
        const BAUD = this.getSettingValue('BAUD');
        if (Number.isNaN(Number(BAUD))) {
            const parts = BAUD.split('_');
            if (!Number.isNaN(Number(parts[parts.length - 1]))) {
                errors.push({ message: 'Invalid Baud Rate', messageType: ValidationMessageType.ERROR });
                errors.push({
                    featureId: this.getID(),
                    settingId: 'BAUD',
                    messageType: ValidationMessageType.UPDATE,
                    message: 'updated baud',
                    data: '9600',
                });
            }
        }
        return errors;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const NAME = this.getSettingValue('NAME');
        const serName = `SER_${NAME}`;
        const project = this.project;
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 05 RS485 setup on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    io.num=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
    io.enabled = YES
    io.state = HIGH
    ${NAME}=${Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.serial}
    ser.num=${serName}
    ser.rtsmap=${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[2]}
    ser.parity=${project.convertDataType(this.getSettingValue('PARITY'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.bits=${project.convertDataType(this.getSettingValue('BITS'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.flowcontrol=${project.convertDataType(this.getSettingValue('FLOWCONTROL'), TibboDataType.STRING, TibboDataType.BYTE)}
    ser.baudrate=ser.div9600*9600/${this.project.convertDataType(this.getSettingValue('BAUD'), TibboDataType.STRING, TibboDataType.DWORD)}
    ser.dircontrol=PL_SER_DCP_LOWFORINPUT
    ser.interface=PL_SER_SI_HALFDUPLEX
    ser.esctype=PL_SER_ET_DISABLED
    ser.interchardelay=0
    ser.txbuffrq(${this.getSettingValue('TXBUF')})
    ser.rxbuffrq(${this.getSettingValue('RXBUF')})
    sys.buffalloc()
    
    ser.enabled=YES
    '-----------------------------------------------------------------

        `,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${serName} = ${Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.serial}
const ${this.getSettingValue('NAME')}_TX = ${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[0]}
const ${this.getSettingValue('NAME')}_RX = ${Tibbits.getSocketPins(this.getSettingValue('SOCKET'), this.project.device.id)[1]}

            `,
        });


        return blocks;
    }
}
